export const state = () => ({
  breakpoints: { xs: '0px', sm: '576px', md: '744px', lg: '1024px', xl: '1366px' },
  containerMaxWidths: { sm: '540px', md: '720px', lg: '960px', xl: '1600px' }
})
